import { FC } from "react";

export const CheckedImage: FC<
  React.PropsWithChildren<{
    color?: string;
  }>
> = (props) => {
  return (
    <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill={"#fff"} />
      <path
        d="M18.3242 0.615297C19.0889 1.41231 19.0628 2.67837 18.2657 3.44312L8.58734 12.7298C7.80677 13.4787 6.57214 13.4713 5.80065 12.713L1.54907 8.534C0.761321 7.7597 0.750418 6.49342 1.52471 5.70568C2.29901 4.91793 3.56529 4.90703 4.35304 5.68132L7.21942 8.49877L15.4963 0.556885C16.2933 -0.207867 17.5594 -0.181715 18.3242 0.615297Z"
        fill={props.color || "#00ED9D"}
      />
    </svg>
  );
};
